import { IconButton, Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import useBookableDurationStore from "../../../stores/useBookableDurationStore";
import WushSortableTable from "../../layout/WushSortableTable";
import ItemCategoryName from "../../text/ItemCategoryName";
import DurationDescription from "../../text/DurationDescription";
import index from "../../../api/auth/items/itemBookableDurations";
import ItemBookableDurationActiveCheck from "../bookableDurations/ItemBookableDurationActiveCheck";
import WushPopover from "../../layout/WushPopover";
import ItemBookableDurationForm from "../itemBookableDurations/ItemBookableDurationForm";
import { Edit } from "@mui/icons-material";

export default function ItemBookableDurations({ item }) {
  const { itemBookableDurations, setItemBookableDurations } = useBookableDurationStore();

  useEffect(() => {
    index(item.id, (response) => {
      setItemBookableDurations(response);
    });
  }, []);

  return (
    <Stack>
      <Stack>
        <ItemCategoryName clickable itemCategory={item.item_category} variant="h6" />
      </Stack>
      <Stack direction="row" spacing={1} mb={2}>
        <Typography variant="h4" fontWeight="700">{item.name}</Typography>
        <Typography variant="h4">booking options</Typography>
      </Stack>
      <Stack>
        <WushSortableTable
          headers={[
            {
              label: "Active",
              customValue: (row) => <ItemBookableDurationActiveCheck itemBookableDuration={row} />
            },
            {
              label: "Name",
              customValue: (row) => <Typography>{row.name || row.bookable_duration.name}</Typography>
            },
            {
              label: "Description",
              customValue: (row) => <DurationDescription bookableDuration={row.bookable_duration} />
            },
            {
              label: "Price",
              customValue: (row) => `$${row.price_dollars}`
            },
            {
              label: "Actions",
              customValue: (row) => (
                <Stack direction="row" spacing={1}>
                  <WushPopover
                    anchor={<Typography>
                      <IconButton>
                        <Edit />
                      </IconButton>
                    </Typography>}
                  >
                    <Stack p={2}>
                      <ItemBookableDurationForm itemBookableDuration={row} />
                    </Stack>
                  </WushPopover>
                </Stack>
              )
            }
          ]}
          data={itemBookableDurations}
        />
      </Stack>
    </Stack>
  );
}